import React, { Component } from 'react';
import { connect } from 'react-redux';
import StatsChart from './charts/statsChart';
import PieChart from './charts/pieChart';
import IncreaseOrDeleteChart from './charts/increaseOrDeleteChart';

@connect(
  state=>state.tenant,
  null
)
class ChartIndex extends Component{
  render() {
    let name;
    if (this.props.tenantInfo) name = this.props.tenantInfo.name;
    return (
      <div>
        <ul id="myTab" className="nav nav-tabs bordered">
          <li  className="active">
            <a id="emailNumbers"
               href="#s1"
               data-toggle="tab">
              Alerts Feed Stats Chart
            </a>
          </li>
          <li>
            <a id="SubscriptionPie"
               href="#s2"
               data-toggle="tab">
              Subscription Status
            </a>
          </li>
          <li>
            <a id="increaseOrDelete"
               href="#s3"
               data-toggle="tab">
              Users Stats Chart
            </a>
          </li>
        </ul>
        <div id="myTabContent"
             className="tab-content padding-10"
             style={{
               backgroundColor: '#efefef',
               borderTop: '1px solid #ddd',
               boxShadow: '0 -2px 1px #ececec'
             }} >
          <StatsChart name={name} />
          <PieChart name={name} />
          <IncreaseOrDeleteChart name={name} />
        </div>
      </div>
    );
  }
}

export default ChartIndex;


// WEBPACK FOOTER //
// ./src/container/dashboard/model/chartIndex.js